import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Get absolute URL for the application
 * Used for Stripe redirect URLs
 */
export function absoluteUrl(path: string, locale?: string): string {
  // Get base URL from environment variables
  let baseUrl = process.env.AUTH_URL;

  // Fallback to Vercel URL if AUTH_URL is not set
  if (!baseUrl && process.env.VERCEL_URL) {
    baseUrl = `https://${process.env.VERCEL_URL}`;
  }

  // Final fallback to localhost
  if (!baseUrl) {
    baseUrl = 'http://localhost:3000';
  }

  // Ensure baseUrl doesn't end with a slash
  baseUrl = baseUrl.replace(/\/$/, '');

  // Add locale to path if provided
  const pathWithLocale = locale ? `/${locale}${path}` : path;

  return `${baseUrl}${pathWithLocale}`;
}
